import React, { useState } from 'react';
import { Button, Space, Typography } from 'antd';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { FctGlifoAtencion, FctIcono } from '../../../fct/react';
import { fct } from '../../../fct/tokens/tokens';
import { LineaInforme } from './reglas';

const { Text } = Typography;

/* Iconos en una tinta (R-14): lo hecho con el icono del manual; aviso y error, con el glifo de
   atención (que lleva su tinta por nivel); lo pendiente, con el punto. */
const ICONO: Record<LineaInforme['estado'], React.ReactNode> = {
  ok: <FctIcono nombre="completado" style={{ width: 14, height: 14 }} />,
  aviso: <FctGlifoAtencion nivel="atencion" />,
  error: <FctGlifoAtencion nivel="urgente" />,
  pendiente: <FctIcono nombre="punto" style={{ width: 14, height: 14 }} />,
};

/**
 * El informe del tratamiento en el lenguaje del operador (§4.5): una línea por cosa hecha,
 * con el detalle por tabla desplegable. Es el eco del modal «Registros relacionados» de
 * Auraquantic, pero contando lo que se ha hecho en vez de lo que hay.
 */
export const InformeFusionView: React.FC<{ lineas: LineaInforme[] }> = ({ lineas }) => {
  const [abiertas, setAbiertas] = useState<Record<string, boolean>>({});
  return (
    <Space direction="vertical" size={4} style={{ width: '100%' }}>
      {lineas.map((l) => {
        const desplegable = l.detalle && l.detalle.length > 0;
        const abierta = abiertas[l.clave] === true;
        return (
          <div key={l.clave}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span style={{ marginTop: 3 }}>{ICONO[l.estado]}</span>
              <Text style={{ flex: 1 }} type={l.estado === 'error' ? 'danger' : undefined}>{l.texto}</Text>
              {desplegable && (
                <Button
                  size="small"
                  type="text"
                  icon={abierta ? <DownOutlined /> : <RightOutlined />}
                  onClick={() => setAbiertas((a) => ({ ...a, [l.clave]: !abierta }))}
                  aria-label="Ver detalle"
                />
              )}
            </div>
            {desplegable && abierta && (
              <ul style={{ margin: '4px 0 4px 24px', paddingLeft: 16, fontSize: 12, color: fct.tinta['700'] }}>
                {l.detalle!.map((d, i) => <li key={i}>{d}</li>)}
              </ul>
            )}
          </div>
        );
      })}
    </Space>
  );
};
